import React from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import tw from 'twin.macro';

import TeamCardGrid from 'components/cards/ProfileThreeColGrid.js';

const Subheading = tw.span`uppercase tracking-wider text-sm`;
export default () => {
  return (
    <AnimationRevealPage>
      <TeamCardGrid subheading={<Subheading>Nuestro Equipo</Subheading>} />
    </AnimationRevealPage>
  );
};
